import APIUtils from '@spothero/utils/api';
const CheckoutEligibilityAPI = {
    checkEligibility(facilityId, config) {
        const data = {
            facility_id: facilityId,
            item_type: 'rental',
        };
        return APIUtils.get('/checkout/eligibility/', data, config);
    },
};
export default CheckoutEligibilityAPI;
